export const Theme = {
    cream: "#FFF2CF",
    creamDeep: "#F5D49A",
    parchment: "#FFF7E4",
    ink: "#632414",
    inkSoft: "#8E4A2A",
    red: "#E7432F",
    redDark: "#8C271E",
    redLight: "#FF7A43",
    orange: "#F59B2E",
    gold: "#F6C348",
    goldDark: "#A65A1C",
    green: "#59B936",
    greenDark: "#287B2E",
    blue: "#2B92C9",
    blueDark: "#13567F",
    navy: "#08253E",
    sky: "#43B7DB",
    cloud: "#FFF4D7",
    muted: "#B68D68",
};

export type ButtonVariant = "red" | "green" | "blue" | "gold" | "cream" | "dark";
